import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";

import widgets from "styles/widgets";
import { UserDto } from "dtos/user.dto";
import displayStyles from "styles/display-styles";
import { ArtistDto } from "dtos/shard/artist.dto";

import ArtistView from "../views/artist-view";
import ArtistEditor from "../editors/artist-editor";
import { statsPanel, toggleStatsPanel } from "utils";

const styles = createUseStyles({});

export default function ArtistDisplay(props: {
    user?: UserDto, // Optional dto of the user.
    className?: string, // Optional css class name to use.
    artist?: Partial<ArtistDto>, // The artist dto to display, if undefined a blank artist will be displayed instead.
    onSave?: (artist: ArtistDto) => void, // A function to call when created or updated.
    onClose?: () => void, // A function to call when the close button is clicked, if not set the close button is hidden.
}): JSX.Element
{
    // States:
    const [stats, setStats] = useState(statsPanel());
    const [artistPreview, setArtistPreview] = useState(props.artist);

    // Effects:
    useEffect(() => {
        setArtistPreview(props.artist);
    }, [props.artist]);

    // Styles:
    const widgetClasses = widgets();
    const displayClasses = displayStyles();
    const classes = styles();

    // Components:
    let statsComp: JSX.Element | undefined;
    if (stats) {
        // Artist Stats (Editor for Admins):
        if (props.user?.super) {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${displayClasses.editor}`}>
                        <h3>Editor:</h3>
                        <ArtistEditor
                            user={props.user}
                            artist={props.artist}
                            preview={artistPreview}
                            onPreviewUpdate={setArtistPreview}
                            onSave={props.onSave}
                            onClose={props.onClose}
                        />
                    </div>
                </div>
            );
        } else {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${widgetClasses.column}`}>
                        <h3>Stats:</h3>
                        <ul>
                            <li>Name: {props.artist?.name}</li>
                        </ul>
                    </div>
                </div>
            );
        }
    }

    // Return Component:
    return (
        <div className={`${displayClasses.container} ${props.className ?? ""}`}>
            <div className={`${displayClasses.controls}`}>
                <div className={`${displayClasses.button} ${statsPanel() ? displayClasses.buttonActive : ""}`} onClick={() => setStats(toggleStatsPanel())}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconStats}`}></div>
                </div>
                {props.onClose && <div className={`${displayClasses.button}`} onClick={() => props.onClose!()}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconClose}`}></div>
                </div>}
            </div>
            <ArtistView artist={artistPreview} />
            {statsComp}
        </div>
    );
}
